import { type FC, useEffect } from 'react';

import { useCurrentProject, useCurrentAccount } from '@adsk/alloy-provider';

import {
  setProjectToContext,
  removeProjectFromContext,
  setAccountToContext,
  removeAccountFromContext,
} from '../utils/monitoring';

export const ProjectAndAccountSetter: FC = () => {
  const project = useCurrentProject();
  const account = useCurrentAccount();

  useEffect(() => {
    if (project) {
      setProjectToContext({
        projectId: project.id,
        projectName: project.name,
      });
    }

    const accountId = project?.accountId || account?.account_id;

    if (accountId) {
      setAccountToContext({
        accountId,
        accountName: project?.accountName || account?.account_display_name,
      });
    }

    return () => {
      removeProjectFromContext();
      removeAccountFromContext();
    };
  }, [project, account]);

  return null;
};
